import React, { PropTypes } from 'react';

const DatabaseIcon = () => (
  <svg
    width="12px"
    height="12px"
    viewBox="205 16 12 12"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="ic_dns_black_24px"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      transform="translate(205.000000, 16.000000)"
    >
      <g id="Group">
        <polygon id="Shape" points="0 0 12 0 12 12 0 12" />
        <path
          d="M10,6.5 L2,6.5 C1.725,6.5 1.5,6.725 1.5,7 L1.5,10 C1.5,10.275 1.725,10.5 2,10.5 L10,10.5 C10.275,10.5 10.5,10.275 10.5,10 L10.5,7 C10.5,6.725 10.275,6.5 10,6.5 Z M3.5,9.5 C2.95,9.5 2.5,9.05 2.5,8.5 C2.5,7.95 2.95,7.5 3.5,7.5 C4.05,7.5 4.5,7.95 4.5,8.5 C4.5,9.05 4.05,9.5 3.5,9.5 Z M10,1.5 L2,1.5 C1.725,1.5 1.5,1.725 1.5,2 L1.5,5 C1.5,5.275 1.725,5.5 2,5.5 L10,5.5 C10.275,5.5 10.5,5.275 10.5,5 L10.5,2 C10.5,1.725 10.275,1.5 10,1.5 Z M3.5,4.5 C2.95,4.5 2.5,4.05 2.5,3.5 C2.5,2.95 2.95,2.5 3.5,2.5 C4.05,2.5 4.5,2.95 4.5,3.5 C4.5,4.05 4.05,4.5 3.5,4.5 Z"
          id="Shape"
          fill="#000000"
        />
      </g>
    </g>
  </svg>
);

const Notifications = ({ connection }) => (
  <div className="logged-in-notification">
    <span>
      Logged in using <span className="bold">{connection.name}</span>
    </span>
    <DatabaseIcon />
  </div>
);

Notifications.propTypes = {
  connection: PropTypes.object.isRequired
};

export default Notifications;



// WEBPACK FOOTER //
// ./src/components/LockHomeDemo/components/Notification.js